import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import work from '../actions/work';
import theme from '../actions/theme';
import WorkList from '../components/WorkList';

// const getVisibleTodos = (todos, filter) => {
//   switch (filter) {
//     case 'SHOW_COMPLETED':
//       return todos.filter(t => t.completed);
//     case 'SHOW_ACTIVE':
//       return todos.filter(t => !t.completed);
//     case 'SHOW_ALL':
//     default:
//       return todos;
//   }
// };

const mapStateToProps = state => ({
  // todos: getVisibleTodos(state.todos, state.visibilityFilter),
  work: state.work,
  theme: state.theme,
});
const mapDispatchToProps = dispatch => ({
  // toggleTodo: id => dispatch(toggleTodo(id)),
  loadWork: bindActionCreators(work.fetch, dispatch),
  loadTheme: bindActionCreators(theme.fetch, dispatch),
});
export default connect(mapStateToProps, mapDispatchToProps)(WorkList);



// WEBPACK FOOTER //
// ./src/containers/Work.js